import React from 'react';
import { CardWrapper } from './styles';
import PaymentInformation from './PaymentInformation';
import OtherInformation from './OtherInformation';
import { Space } from 'antd';
import FailQCInformation from './FailQCInformation';

const OrderPriceDetail = ({ data }) => {
  return (
    <Space size={10} direction="vertical" className="w-full">
      <CardWrapper title="Payment Information">
        <PaymentInformation data={data} />
      </CardWrapper>
      <CardWrapper title="Other Information">
        <OtherInformation data={data} />
      </CardWrapper>
      {data?.statusOms === 'FAIL_QC' && (
        <CardWrapper title="Fail QC Information">
          <FailQCInformation data={data} />
        </CardWrapper>
      )}
    </Space>
  );
};

export default OrderPriceDetail;
